import React, { useState, useEffect } from "react";
import "./Desiredlocation.css";
import { Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchKeySearchLocation,
  candidateDetailSuccess,
} from "../../../../../redux/actions";
import { debounce } from "../../../../../shared/helpers";
import CandidateSignupButton from "../CandidateBackNext/CandidateSignupButton";
import history from "../../../../../routes/history";
import errorIcon from "../../../../../assets/img/ci_warning.png";
import ProgressBar from "../../../../../components/ProgressBar/ProgressBar";
import GigListing from "./../../../../GigManagement/GigListing/GigListing";
import SelectionItem from "./SelectionItem";

function DesiredLocation(props) {
  const dispatch = useDispatch();
  const { Option } = Select;

  const getInputValues = useSelector(
    (state) => state.candidateReducer.candidateDetails
  );

  const skillListingCities =
    getInputValues?.skillListing?.skillListings_Cities || [];
  const [locations, setLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] =
    useState(skillListingCities);
  const [desiredLocations, setDesiredLocations] = useState(skillListingCities);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [noDataViewSkills, setNoDataViewSkills] = useState("");

  const location = useSelector(
    (state) => state.credentialingReducer.searchedLocation
  );
  const loader = useSelector((state) => state.credentialingReducer.skillLoader);

  useEffect(() => {
    if (location.length) {
      setLocations(location);
    } else {
      setLocations([]);
    }
  }, [location]);

  const onSearchLocation = (value) => {
    setShowError(false);
    if (value !== "") {
      setNoDataViewSkills(value);
      dispatch(fetchKeySearchLocation(value));
    }
  };

  const onSelectLocation = (loc) => {
    try {
      const _selectedLocations = [...selectedLocations, JSON.parse(loc)];
      setDesiredLocations(_selectedLocations);
      setSelectedLocations(_selectedLocations);
      // dispatch(
      //   candidateDetailSuccess({
      //     ...getInputValues,
      //     skillListing: {
      //  ...(getInputValues?.skillListing || {}),
      //       skillListings_Cities: [..._selectedLocations],
      //     },
      //   })
      // );
    } catch (error) {
      console.warn("error", error);
    }
  };

  const onDeselectLocation = (loc) => {
    try {
      const _selectedLocations = selectedLocations.filter(
        (el) => el.LocationWithCountry !== JSON.parse(loc).LocationWithCountry
      );
      setDesiredLocations(_selectedLocations);
      setSelectedLocations(_selectedLocations);
      dispatch(
        candidateDetailSuccess({
          ...getInputValues,
          skillListing: {
       ...(getInputValues?.skillListing || {}),
            skillListings_Cities: [..._selectedLocations],
          },
        })
      );
    } catch (error) {
      console.warn("error", error);
    }
  };

  const locationPlaceholder = () => (
    <div className="placeholder-new-signup-loc-skill">
      <div className="example">ex.</div>
      <div className="circle-box">
        <span>Houston, TX</span>
      </div>
      <div className="circle-box">
        <span>Ferry Pass, FL</span>
      </div>
    </div>
  );

  const nextFunction = () => {
    setLoading(true);
    if (desiredLocations?.length) {
      dispatch(
        candidateDetailSuccess({
          ...getInputValues,
          skillListing: {
            ...(getInputValues?.skillListing || {}),
            skillListings_Cities: [...selectedLocations],
          },
        })
      );
      setLoading(false);
      history.push("/candidate-salary");
    } else {
      setLoading(false);
      setShowError(true);
    }
  };

  const backFunction = () => {
    history.push("/candidate-skill");
  };

  const skipFunction = () => {
    history.push("/candidate-salary");
  };
  console.log("selectedLocations", selectedLocations);

  return (
    <div className="profilecompleteion">
      <div>
        <ProgressBar
          heading={"Create candidate’s skill listing"}
          percent={80}
        />
        <div className="email-text">
          Your desired locations
          <div className="email-mandatory">(Optional)</div>
        </div>
        <div className="locat-sub">
          <span>Add candidate’s preferred work locations here</span>
        </div>
        <div className="Loc-mobile">
          <div className="mobilesub"></div>
          <div className="sub-div">
            {/* {selectedLocations.length === 0 ? (
              <div className="no-locations-message">
                No preferred locations selected. Please add your desired work
                locations.
              </div>
            ) : ( */}
            <Select
              mode="multiple"
              value={selectedLocations?.map((location) =>
                JSON.stringify(location)
              )}
              onSearch={debounce((val) => onSearchLocation(val), 700)}
              onSelect={onSelectLocation}
              onDeselect={onDeselectLocation}
              style={{ width: "100%" }}
              showSearch
              listHeight={160}
              autoFocus
              className={`desired-loc-skill${showError ? " error-block" : ""}`}
              placeholder={locationPlaceholder()}
              tagRender={({ value }) => {
                const _tag = JSON.parse(value);
                return (
                  <SelectionItem
                    title={_tag?.LocationWithCountry || "N/A"}
                    value={value}
                    onRemove={onDeselectLocation}
                  />
                );
              }}
              notFoundContent={
                noDataViewSkills?.length > 0 ? (
                  <div>
                    {loader || locations.length > 0 ? (
                      <Spin size="small" />
                    ) : (
                      "No data found!"
                    )}
                  </div>
                ) : null
              }
            >
              {locations.map((location) => (
                <Option
                  value={JSON.stringify(location)}
                  key={location.LocationWithCountry}
                >
                  {location.LocationWithCountry}
                </Option>
              ))}
            </Select>
            {/* )} */}
          </div>
        </div>
        {showError && (
          <div className="error-msg-content">
            <img src={errorIcon} alt="" />
            <span className="error-text">
              Please add your desired location to continue
            </span>
          </div>
        )}
        <div style={{ paddingTop: "15%" }}>
          <CandidateSignupButton
            nextFunction={nextFunction}
            backFunction={backFunction}
            nextBtnLoading={loading}
            skipFunction={skipFunction}
          />
        </div>
      </div>
    </div>
  );
}

export default DesiredLocation;
